import React, { useRef, useState } from 'react'
import { useFormikContext } from 'formik'
import { useQuery } from 'react-query'
import { useRouter } from 'next/router'

import { useMyWritingAction } from '@hooks/book/myWriting/useMyWritingAction'
import { useOutside } from '@hooks/useOutside'
import { EbookByUserIdType } from '@models/myWriting/salesAndAnalytics/EbookByUserIdType'
import { SearchEbookFieldProps, WithSearchEbookFieldProps } from './interface'
import { SaleAndAnalyticsQueryParams } from '../../interfaces/SaleAndAnalyticsQueryParams'

const withSearchEbookField = (Component: React.FC<SearchEbookFieldProps>) => {
  function WithSearchEbookField({ name, ...props }: WithSearchEbookFieldProps) {
    const searchRef = useRef<HTMLDivElement>(null)
    const [text, setText] = useState('')
    const searchText = useRef('')
    const myWritingClient = useMyWritingAction()
    const router = useRouter()
    const [isShowSearchLog, setIsShowSearchLog] = useState<boolean>(false)
    const { setFieldValue, submitForm } =
      useFormikContext<SaleAndAnalyticsQueryParams>()

    useOutside(searchRef, () => {
      hideSearchLog()
      setText(searchText.current)
    })

    const { data: ebooks = [] } = useQuery(
      ['ebook', 'sale-analytic'],
      () => myWritingClient.getEbooksTitleAndIdByUser(''),
      {
        onSuccess: res => {
          if (router.query.ebookId) {
            const ebook = res.find(
              item => item.ebookId === Number(router.query.ebookId)
            )
            const ebookTitle = ebook?.ebookTitle || ''
            setText(ebookTitle)
            searchText.current = ebookTitle
          }
        },
      }
    )

    function showSearchLog() {
      setIsShowSearchLog(true)
    }

    function hideSearchLog() {
      setIsShowSearchLog(false)
    }

    function handleTextChange(event: React.ChangeEvent<HTMLInputElement>) {
      setText(event.target.value)
    }

    function handleSelectBook(ebook: EbookByUserIdType) {
      setFieldValue(name, ebook.ebookId)
      setText(ebook.ebookTitle)
      searchText.current = ebook.ebookTitle
      submitForm()
      hideSearchLog()
    }

    function removeSearchText() {
      searchText.current = ''
      setFieldValue(name, undefined)
      setText('')
      submitForm()
    }

    const componentsProps = {
      ...props,
      text,
      isShowSearchLog,
      ebooks: ebooks.filter(row => row.ebookTitle.includes(text)),
      inputRef: searchRef,
      showSearchLog,
      hideSearchLog,
      handleSelectBook,
      handleTextChange,
      removeSearchText,
    }
    return <Component {...componentsProps} />
  }

  return WithSearchEbookField
}

export { withSearchEbookField }
